import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import reqsMet from "../azReqsMet.png";

// Create styles
const styles = StyleSheet.create({
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
    textAlign: "left",
  },
  text: {
    margin: 12,
    fontSize: 14,
    textAlign: "left",
    fontFamily: "Roboto",
  },
  boldText: {
    margin: 12,
    fontSize: 14,
    textAlign: "left",
    fontFamily: "Roboto",
    fontWeight: "bold",
  },
  headerText: {
    margin: 12,
    fontSize: 24,
    textAlign: "center",
    fontFamily: "Roboto",
  },
  subHeaderText: {
    margin: 12,
    fontSize: 14,
    textAlign: "center",
    fontFamily: "Roboto",
  },
  image: {
    marginLeft: "85%",
    width: "15%",
    height: "auto",
    zindex: 100,
  },
});

// Create Document Component
export const SummaryDoc = (props) => {
  return (
    <Document>
      <Page size="A4" wrapping={true}>
        <View style={styles.section}>
          <Image src={reqsMet} style={styles.image} />
          <Text style={styles.headerText}>Halo Infusions & Extractions</Text>
          <Text style={styles.subHeaderText}>
            Result Summary for {props.name}
          </Text>
          <Text style={styles.text}>
            <Text style={styles.boldText}>Batch</Text>: {props.batch}
          </Text>
          <Text style={styles.text}>
            <Text style={styles.boldText}>Disposition Date</Text>:{" "}
            {props.date.split("T")[0]}
          </Text>
          {props.summary}
          <Text style={styles.text}>
            For more test results vists: https://haloinfusions.com/testing
          </Text>
        </View>
      </Page>
    </Document>
  );
};
